import { DDSLabelText, DDSMicroText } from "@web-monorepo/dds";
import styles from "./ToolkitGridSplitItem.module.css";

type ToolkitGridSplitItemProps = {
  index: number;
  title: string;
  subTitle?: string;
  imgSrc: string;
  onItemClick: VoidFunction;
};

// The entire image-and-caption tile is the button's click target.
function ToolkitGridSplitItem(props: ToolkitGridSplitItemProps) {
  return (
    <div>
      <button
        type="button"
        aria-label={props.title}
        data-name={`toolkit_grid_split_item:${props.index}`}
        key={props.index}
        onClick={() => props.onItemClick()}
        className={styles.gridSplitItemButton}
      >
        <img src={props.imgSrc} alt="" className={styles.image} />
        <div className={styles.caption}>
          <DDSLabelText>{props.title}</DDSLabelText>
          {props.subTitle && <DDSMicroText className={styles.subTitle}>{props.subTitle}</DDSMicroText>}
        </div>
      </button>
    </div>
  );
}

export default ToolkitGridSplitItem;
